import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ACCOUNT_CREDIT, API_PAYOUT, API_RECHARGE_REQUESTS, API_WALLET_BALANCE, BANK_ACCOUNT_DETAILS, CREATE_EMPLOYEMENT_ORDER, DOWNLOAD_CREDITS, DOWNLOAD_WITHDRAWAL_STATEMENT, PAYMENT_VERIFY_OTP, PAYMENT_VIA_CREDIT } from '../util/api.endpoints';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreditsService {
  public refreshCreditsHeader = new Subject<any>();

  constructor(
    private http: HttpClient
  ) { }

  // get recharge requests lists
  fetchRechargeRequestsList(params: any) {
    let url = API_RECHARGE_REQUESTS;
    return this.http.get<any>(url, { params });
  }

  // send request for credit
  sendRequestForCredit(params: any) {
    const url = API_RECHARGE_REQUESTS;
    return this.http.post<any>(url, params);
  }

  // update recharge requests status
  updateRechargeRequestStatus(rechargeId: any, rechargeStatus: any, otp: any) {
    const url = API_RECHARGE_REQUESTS + '/update?rechargeId=' + rechargeId + '&rechargeStatus=' + rechargeStatus + '&otp=' + otp;
    return this.http.get<any>(url);
  }

  // fetch wallet balance
  fetchWalletBalance(entityId: any) {
    const url = API_WALLET_BALANCE + '/' + entityId;
    return this.http.get<any>(url);
  }

  // fetch Task credit 
  fetchTaskCreditBalance(entityId: any) {
    const url = API_ACCOUNT_CREDIT + '/' + entityId;
    return this.http.get<any>(url);
  }

  // fetch wallet balance
  fetchPayouts(entityId: any, page: any, size: any) {
    const url = API_PAYOUT + '/' + entityId + '?pageNumber=' + page + '&pageSize=' + size;
    return this.http.get<any>(url);
  }

  // add Bank Account Details
  addBankAccountDetails(params: any) {
    const url = BANK_ACCOUNT_DETAILS;
    return this.http.post<any>(url, params);
  }

  // update Bank Account Details
  updateBankAccountDetails(bankAccountId: any, params: any) {
    const url = BANK_ACCOUNT_DETAILS + '/' + bankAccountId;
    return this.http.put<any>(url, params);
  }

  // fetch bank accounts lists
  fetchBankAccountDetailsList(entityId: any) {
    const url = BANK_ACCOUNT_DETAILS + '?entityId=' + entityId;
    return this.http.get<any>(url);
  }

  // fetch bank account details by ID
  fetchBankAccountDetailById(entityId: any) {
    const url = BANK_ACCOUNT_DETAILS + '/' + entityId;
    return this.http.get<any>(url);
  }

  // payment Verify OTP Send
  paymentVerifyOTPSend(params: any) {
    const url = PAYMENT_VERIFY_OTP;
    return this.http.post<any>(url, params);
  }

  // fund transfter wallet to bank account
  fundTransfterWalletToBankAccount(params: any) {
    const url = API_PAYOUT;
    return this.http.post<any>(url, params);
  }

  updatePaymentStatusOrderId(id: any, params: any) {
    const url = CREATE_EMPLOYEMENT_ORDER + '/' + id;
    return this.http.put<any>(url, params);
  }

  // refresh cash & task credit header
  setRefreshCreditsHeader(data?: any) {
    this.refreshCreditsHeader.next(data);
  }

  getRefreshCreditsHeader(): Subject<any> {
    return this.refreshCreditsHeader;
  }

  // Payment made with wallet balance
  paymentViaCashWallet(params: any) {
    const url = PAYMENT_VIA_CREDIT;
    return this.http.post<any>(url, params);
  }

  // fetch paid wallet balance details lists
  fetchpayoutWalletBalanceDetails(params, entityId: any) {
    const url = API_PAYOUT + '/' + entityId;
    return this.http.get<any>(url, { params });
  }

  exportPayouts(entityId: any) {
    const url = DOWNLOAD_WITHDRAWAL_STATEMENT + '/' + entityId;
    return this.http.get<any>(url, {
      responseType: 'blob' as 'json', // 'blob' responseType must be cast as 'json' for TypeScript
      observe: 'response'
    });
  }

  exportCredits(entityId: any) {
    const url = DOWNLOAD_CREDITS + '?entityId=' + entityId;
    return this.http.get<any>(url, {
      responseType: 'blob' as 'json', // 'blob' responseType must be cast as 'json' for TypeScript
      observe: 'response'
    });
  }

}
